import { reportG4 } from "./../services/reportG4.service";
import { MessageBox, Loading } from "element-ui";
const moment = require("moment");
const month_th = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน ",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม"
];
const month_th_abbreviation =[
  "ม.ค.-",
  "ก.พ.-",
  "มี.ค.-",
  "เม.ย.-",
  "พ.ค.-",
  "มิ.ย.- ",
  "ก.ค.-",
  "ส.ค.-",
  "ก.ย.-",
  "ต.ค.-",
  "พ.ย.-",
  "ธ.ค.-"
]
const frequency_th = {
  900: "คลื่นความถี่ 900 MHz",
  1800: "คลื่นความถี่ 1800 MHz",
  2100: "คลื่นความถี่ 2.1 GHz",
  other: "คลื่นความถี่อื่นๆ",
}
const labelAsset = {
  Voice: "เสียง (บาท/นาที)",
  SMS: "SMS (บาท/ข้อความ)",
  MMS: "MMS (บาท/ข้อความ)",
  Internet: "Internet (บาท/MB)"
};
const service_title = {
  Voice: 'เสียง',
  SMS: ' SMS',
  MMS: ' MMS',
  Internet: ' Internet'
}
const service_rate = {
  Voice: 'voice_service_rate',
  SMS: 'sms_service_rate',
  MMS: 'mms_service_rate',
  Internet: 'internet_service_rate'
}
const service_sum = {
  Voice: 'vpm_sum',
  SMS: 'sms_sum',
  MMS: 'mms_sum',
  Internet: 'internet_sum'
}
const service_amount = {
  Voice: 'vpm_amount',
  SMS: 'sms_amount',
  MMS: 'mms_amount',
  Internet: 'internet_amount'
}

const state = {
  loading: false,
  test: 20,
  res: 0,
  showChart: false, 
  showDataNotFound: false,
  prototype: {
    all_service: {
      chart: {
        type: "column",
      },
      title: {
        text: "",
        align: "center",
      },
      yAxis: {
        min: 0,
        title: {
          text: "หน่วย :บาท"
        },
        tickInterval:0.05,
      },
      xAxis: {
        categories: [],
        min: 0,
        max: undefined,
        showFirstLabel: true,
        showLastLabel: true
      },
      credits: {
          enabled: false
      },
      tooltip: {
        shared: true,
        enabled: true
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 0,
          animation: {
              duration: 1000
          },
          opacity: 1,
          // overflow: "allow",
          // crop: false
          overflow: "allow",
          crop: false,
          allowOverlap: true
        }
      },
      series: [],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom"
              }
            }
          }
        ]
      },
      exporting: {
        buttons: {
          contextButton:{
              menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
          }
        }
      }
    },
    one_service: {
      chart: {
        type: "column",
      },
      title: {
        text: "",
        align: "center",
      },
      yAxis: {
        min: 0,
        title: {
          text: "หน่วย :บาท"
        },
        tickInterval:0.05,
      },
      xAxis: {
        categories: [],
        min: 0,
        max: undefined,
        showFirstLabel: true,
        showLastLabel: true
      },
      credits: {
          enabled: false
      },
      tooltip: {
        shared: true,
        enabled: true
      },
      plotOptions: {
        column: {
          grouping: false,
          shadow: false,
          borderWidth: 0,
          animation: {
              duration: 1000
          },
          overflow: "allow",
          crop: false
        }
      },
      series: [],
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom"
              }
            }
          }
        ]
      },
      exporting: {
        buttons: {
            contextButton:{
                menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]
            }
        }
      },
    }
  },
  charts: [],
  datasets: [],
  options: {},
  regulates: [],
  groupList: [],
  providerList: [],
  quarterdata: [],
  service_rate_regulate: []
};

const actions = {

  async setChartData({ commit }, formdata) {

    let result = await reportG4.getReportData(formdata);
    let result_fixed = await reportG4.getReportDataFixed(formdata)
    let service_regulate = await reportG4.getServiceRegulate()
    let propotion = await reportG4.getPropotionMobileService()
      if (propotion.status===200&&result.status===200 &&result_fixed.status===200 && service_regulate.status === 200) {
        if(result_fixed.data.length==0&&result.data.length==0){
          state.showDataNotFound = true
          state.showChart = false
          setTimeout(function(){ loadingInstance.close() }, 250);
        }
        else{
          state.showDataNotFound = false
          state.showChart = true
          let title = ''
          if(formdata.typeService == 'all'){
            title = 'อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet ของผู้ให้บริการโทรศัพท์เคลื่อนที่'
            switch(formdata.type_report) {
              case 'month':
                title += ' เดือน' + month_th[moment(formdata.type_data.month).month()] + ' ปี พ.ศ. ' + moment(formdata.type_data.month).add(543, 'y').year()
                break;
              case 'between_month':
                break;
              case 'year':
                break;
              case 'between_year':
                break;
              case 'quarter':
                break;
              case 'between_quarter':
                break;
            }
            title += ' โดยเปรียบเทียบกับอัตราค่าบริการเฉลี่ยอ้างอิงของการกากับดูแล'
          } else {
            switch(formdata.type_report) {
              case 'month':
                break;
              case 'between_month':
                break;
              case 'year':
                break;
              case 'between_year':
                break;
              case 'quarter':
                break;
              case 'between_quarter':
                break;
            }
          }
          switch (formdata.type_report) {
            case "month":{
              let temp = moment(formdata.type_data.month).add(1, "M")._d;
              let obj = {
                forminfo: formdata,
                qrydata: result.data,
                qrydataFixed: result_fixed.data,
                qrydataServiceRegulate: service_regulate.data,
                qrypropotion: propotion.data,
                date: {
                  start: moment(formdata.type_data.month, "YYYY-MM-DD")._d,
                  end: moment(temp).subtract(1, "seconds")._d
                }
              };
              commit("MONTH", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "year":{
              let temp = moment(formdata.type_data.year, "YYYY-MM-DD").add(1, "Y")
                ._d;
              let obj = {
                forminfo: formdata,
                qrydata: result.data,
                qrypropotion: propotion.data,
                qrydataFixed: result_fixed.data,
                qrydataServiceRegulate: service_regulate.data,
                date: {
                  start: moment(formdata.type_data.year, "YYYY-MM-DD")._d,
                  end: moment(temp).subtract(1, "seconds")._d
                }
              };
              commit("YEAR", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "between_month":{
              let temp = moment(formdata.type_data.monthto).add(1, "M")._d;
              let obj = {
                date: {
                  start: formdata.type_data.monthfrom,
                  end: moment(temp).subtract(1, "seconds")._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrypropotion: propotion.data,
                qrydataFixed: result_fixed.data,
                qrydataServiceRegulate: service_regulate.data,
              };
              commit("BETWEEN_MONTH", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "between_year":{
              let temp = moment(formdata.type_data.yearto).add(1, "year")._d;
              let obj = {
                date: {
                  start: formdata.type_data.yearfrom,
                  end: moment(temp).subtract(1, "seconds")._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrydataServiceRegulate: service_regulate.data,
                qrydataFixed: result_fixed.data,
                qrypropotion: propotion.data,
              };
              commit("BETWEEN_YEAR", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "quarter":{
              let obj = {
                date: {
                  start: moment(formdata.type_data.quarter_year).add(
                    formdata.type_data.quarter * 3 - 3,
                    "Month"
                  )._d,
                  end: moment(formdata.type_data.quarter_year).add(
                    formdata.type_data.quarter * 3,
                    "Month"
                  )._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrydataServiceRegulate: service_regulate.data,
                qrydataFixed: result_fixed.data,
                qrypropotion: propotion.data,
              };
              commit("QUARTER", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
            case "between_quarter":{
              let obj = {
                date: {
                  start: moment(formdata.type_data.quarter_year_from).add(
                    formdata.type_data.quarterfrom * 3 - 3,
                    "Month"
                  )._d,
                  end: moment(formdata.type_data.quarter_year).add(
                    formdata.type_data.quarterto * 3,
                    "Month"
                  )._d
                },
                forminfo: formdata,
                qrydata: result.data,
                qrydataFixed: result_fixed.data,
                qrydataServiceRegulate: service_regulate.data,
                qrypropotion: propotion.data,
              };
              commit("BETWEEN_QUARTER", obj);
              setTimeout(function(){ loadingInstance.close() }, 250);
              break;
            }
          }
        }
        
      }else {
        setTimeout(function(){ loadingInstance.close() }, 250);
        MessageBox.confirm(result.message, "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        });
      }
    
  },

  async setServiceRateList({ commit }) {
    let result = await reportG4.getServiceRegulateList()
    commit('SET_SERVICE_RATE', result.data.data)
  },

  async setAllServiceChart({commit}, formdata){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    commit('CLEAR_CHART');
    state.loading = true
    state.showDataNotFound = false
    let daterange = []
    let result = await reportG4.getReportData(formdata)
    let propotion = await reportG4.getPropotionMobileService()
    if(result.data.report_data.length == 0) {
      state.showDataNotFound = true
      state.showChart = false
      setTimeout(function(){ loadingInstance.close() }, 250);
      return state.loading = false
    }
    let weightingData = null
    if(formdata.weighting){
      weightingData = {
        provider_id_list: result.data.weightingData.provider_id_list,
        promotion: result.data.weightingData.promotion
      }
    }
    let service_regulate = formdata.regulator
    let ref_service_regulate = {
      voice_service_rate: service_regulate.voice_service_rate,
      sms_service_rate: service_regulate.sms_service_rate,
      mms_service_rate: service_regulate.mms_service_rate,
      internet_service_rate: service_regulate.internet_service_rate
    }
    let obj_data = {
      formdata: formdata,
      querydata: result.data.report_data,
      propotion: {
        main: propotion.data[0].proportion_main_promotion,
        ontop: propotion.data[0].proportion_ontop_promotion
      },
      service_regulate: ref_service_regulate,
      weightingData: weightingData
    }
    let title = 'อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet ของผู้ให้บริการโทรศัพท์เคลื่อนที่'
    switch(formdata.type_report) {
      case 'month':
        daterange = [
          moment(formdata.type_data.month).format('YYYY-MM-DD'),
          moment(formdata.type_data.month).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        formdata.title = title
        formdata.daterange = daterange
        commit('SET_ALL_SERVICE_CHART', obj_data)
        setTimeout(function(){ loadingInstance.close() }, 250);
        break;
      case 'between_month':
        daterange = [
          moment(formdata.type_data.monthfrom).format('YYYY-MM-DD'),
          moment(formdata.type_data.monthto).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        formdata.title = title
        formdata.daterange = daterange
        commit('SET_ALL_SERVICE_CHART', obj_data)
        setTimeout(function(){ loadingInstance.close() }, 250);
        break;
      case 'year':
        daterange = [
          moment(formdata.type_data.year).format('YYYY-MM-DD'),
          moment(formdata.type_data.year).add(1, 'y').subtract(1, 'd').format('YYYY-MM-YY')
        ]
        formdata.title = title
        formdata.daterange = daterange
        commit('SET_ALL_SERVICE_CHART_YEAR', obj_data)
        setTimeout(function(){ loadingInstance.close() }, 250);
        break;
      case 'between_year':
        daterange = [
          moment(formdata.type_data.yearfrom).format('YYYY-MM-DD'),
          moment(formdata.type_data.yearto).add(1, 'y').subtract(1, 'M').format('YYYY-MM-DD')
        ]
        formdata.title = title
        formdata.daterange = daterange
        commit('SET_ALL_SERVICE_CHART_YEAR', obj_data)
        setTimeout(function(){ loadingInstance.close() }, 250);
        break;
      case 'quarter':
        daterange = [
          moment(formdata.type_data.quarter_year).add((formdata.type_data.quarter - 1) * 3,'M').format('YYYY-MM-DD'),
          moment(formdata.type_data.quarter_year).add(formdata.type_data.quarter * 3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        formdata.title = title
        formdata.daterange = daterange
        commit('SET_ALL_SERVICE_CHART_QUARTER', obj_data)
        setTimeout(function(){ loadingInstance.close() }, 250);
        break;
      case 'between_quarter':
        daterange = [
          moment(formdata.type_data.quarter_year_from).add((formdata.type_data.quarterfrom - 1) * 3,'M').format('YYYY-MM-DD'),
          moment(formdata.type_data.quarter_year).add(formdata.type_data.quarterto * 3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        formdata.title = title
        formdata.daterange = daterange
        commit('SET_ALL_SERVICE_CHART_QUARTER', obj_data)
        setTimeout(function(){ loadingInstance.close() }, 250);
        break;
    }
  },

  async setOneServiceChart({commit}, formdata){
    let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
    commit('CLEAR_CHART');
    state.loading = true
    state.showDataNotFound = false
    let daterange = []
    let result = await reportG4.getReportData(formdata)
    let propotion = await reportG4.getPropotionMobileService()
    if(result.data.report_data.length == 0) {
      state.showDataNotFound = true
      state.showChart = false
      setTimeout(function(){ loadingInstance.close() }, 250);
      return state.loading = false
    }
    let weightingData = null
    if(formdata.weighting){
      weightingData = {
        provider_id_list: result.data.weightingData.provider_id_list,
        promotion: result.data.weightingData.promotion
      }
    }
    let title = 'การเปลี่ยนแปลงอัตราค่าบริการเฉลี่ยของบริการประเภท' + service_title[formdata.service_type]
    switch(formdata.type_report) {
      case 'month':
        daterange = [
          moment(formdata.type_data.month).format('YYYY-MM-DD'),
          moment(formdata.type_data.month).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        title += ' เดือน' + month_th[moment(daterange[0]).month()] + ' ปี พ.ศ. ' + moment(daterange[0]).add(543, 'y').year()
        title += ' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'
        break;
      case 'between_month':
        daterange = [
          moment(formdata.type_data.monthfrom).format('YYYY-MM-DD'),
          moment(formdata.type_data.monthto).add(1, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        title += ' ระหว่างเดือน' + month_th[moment(daterange[0]).month()] + ' ปี พ.ศ. ' + moment(daterange[0]).add(543, 'y').year() + ' ถึงเดือน' + month_th[moment(daterange[1]).month()] + ' ปี พ.ศ. ' + moment(daterange[1]).add(543, 'y').year()
        title += ' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'
        break;
      case 'year':
        daterange = [
          moment(formdata.type_data.year).format('YYYY-MM-DD'),
          moment(formdata.type_data.year).add(1, 'y').subtract(1, 'd').format('YYYY-MM-YY')
        ]
        title += ' ปี พ.ศ. ' + moment(daterange[0]).add(543, 'y').year()
        title += ' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'
        break;
      case 'between_year':
        daterange = [
          moment(formdata.type_data.yearfrom).format('YYYY-MM-DD'),
          moment(formdata.type_data.yearto).add(1, 'y').subtract(1, 'M').format('YYYY-MM-DD')
        ]
        title += ' ปี พ.ศ. ' + moment(daterange[0]).add(543, 'y').year() + ' ถึงปี พ.ศ. ' + moment(daterange[1]).add(543, 'y').year()
        title += ' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'
        break;
      case 'quarter':
        daterange = [
          moment(formdata.type_data.quarter_year).add((formdata.type_data.quarter-1)*3,'M').format('YYYY-MM-DD'),
          moment(formdata.type_data.quarter_year).add(formdata.type_data.quarter*3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        title += ' ในไตรมาสที่ ' + formdata.type_data.quarter + ' ปี พ.ศ. ' + moment(daterange[0]).add(543, 'y').year()
        title += ' ของผู้ให้บริการโทรศัพท์เคลื่อนที่'
        break;
      case 'between_quarter':
        daterange = [
          moment(formdata.type_data.quarter_year_from).add((formdata.type_data.quarterfrom-1)*3,'M').format('YYYY-MM-DD'),
          moment(formdata.type_data.quarter_year).add(formdata.type_data.quarterto*3, 'M').subtract(1, 'd').format('YYYY-MM-DD')
        ]
        title = 'แนวโน้มอัตราค่าบริการเฉลี่ยของบริการประเภท' + service_title[formdata.service_type] + 'ในไตรมาสที่ ' + formdata.type_data.quarterfrom + ' ปี พ.ศ. ' + moment(daterange[0]).add(543, 'y').year() + ' ถึงไตรมาสที่ ' + formdata.type_data.quarterto + ' ปี พ.ศ. ' + moment(daterange[1]).add(543, 'y').year()
        break;
    }
    title += ' (บน' + frequency_th[formdata.frequency] + ')'
    formdata.title = title
    formdata.daterange = daterange
    let service_regulate = formdata.regulator
    let ref_service_regulate = {
      voice_service_rate: service_regulate.voice_service_rate,
      sms_service_rate: service_regulate.sms_service_rate,
      mms_service_rate: service_regulate.mms_service_rate,
      internet_service_rate: service_regulate.internet_service_rate
    }
    let obj_data = {
      formdata: formdata,
      querydata: result.data.report_data,
      propotion: {
        main: propotion.data[0].proportion_main_promotion,
        ontop: propotion.data[0].proportion_ontop_promotion
      },
      service_regulate: ref_service_regulate,
      weightingData: weightingData
    }
    if(formdata.type_report == 'month' || formdata.type_report == 'between_month' ){
      commit('SET_SERVICE_CHART', obj_data)
      setTimeout(function(){ loadingInstance.close() }, 250);
    } else if(formdata.type_report == 'year' || formdata.type_report == 'between_year'){
      commit('SET_SERVICE_CHART_YEAR', obj_data)
      setTimeout(function(){ loadingInstance.close() }, 250);
    } else if(formdata.type_report == 'between_quarter' || formdata.type_report == 'quarter'){
      commit('SET_SERVICE_CHART_QUARTER', obj_data)
      setTimeout(function(){ loadingInstance.close() }, 250);
    }
  }
};

const mutations = {
  CLEAR_CHART(state){
    state.charts = []
  },
  SET_ALL_SERVICE_CHART(state, obj){
    let formdata = obj.formdata
    let data = obj.querydata
    let propotion = obj.propotion
    let service_regulate = obj.service_regulate
    let provider_id_list = formdata.type_providers == 'group' ? JSON.parse('[' + formdata.provider_group.group_company_list.slice(1,-1) + ']') : [formdata.provider_list.id]
    for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
      let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
      let month_avg = {
        Voice: 0,
        SMS: 0,
        MMS: 0,
        Internet: 0
      }
      let month_amount = 0
      for(let p = 0; p < provider_id_list.length; p++){
        let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
        let main = monthly_provider.filter(type => type.promotion_type == 'main')
        let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
        main = main.length > 0 ? main[0] : []
        ontop = ontop.length > 0 ? ontop[0] : []
        if(monthly_provider.length == 0) continue;
        if(moment(start).year() >= 2020){
          if((main.length != 0) && (ontop.length != 0)){
            if(ontop.vpm_amount != 0){
              month_avg.Voice += ((main.vpm_sum/main.vpm_amount)*(propotion.main/100)) + ((ontop.vpm_sum/ontop.vpm_amount)*(propotion.ontop/100))
            } else {
              month_avg.Voice += main.vpm_sum/main.vpm_amount
            }
            if(ontop.sms_amount != 0){
              month_avg.SMS += ((main.sms_sum/main.sms_amount)*(propotion.main/100)) + ((ontop.sms_sum/ontop.sms_amount)*(propotion.ontop/100))
            } else {
              month_avg.SMS += main.sms_sum/main.sms_amount
            }
            if(ontop.mms_amount != 0){
              month_avg.MMS += ((main.mms_sum/main.mms_amount)*(propotion.main/100)) + ((ontop.mms_sum/ontop.mms_amount)*(propotion.ontop/100))
            } else {
              month_avg.MMS += main.mms_sum/main.mms_amount
            }
            if(ontop.internet_amount != 0){
              month_avg.Internet += ((main.internet_sum/main.internet_amount)*(propotion.main/100)) + ((ontop.internet_sum/ontop.internet_amount)*(propotion.ontop/100))
            } else {
              month_avg.Internet += main.internet_sum/main.internet_amount
            }
            month_amount++
          } else if((main.length != 0) && (ontop.length == 0)){
            month_avg.Voice += main.vpm_sum/main.vpm_amount
            month_avg.SMS += main.sms_sum/main.sms_amount
            month_avg.MMS += main.mms_sum/main.mms_amount
            month_avg.Internet += main.internet_sum/main.internet_amount
            month_amount++
          }
        } else {
          let temp_avg = monthly_fixed(monthly_provider)
          if (temp_avg.Voice != undefined) {
            month_avg.Voice += temp_avg.Voice
            month_avg.SMS += temp_avg.SMS
            month_avg.MMS += temp_avg.MMS
            month_avg.Internet += temp_avg.Internet
            month_amount++
          }
        }
      }
      let final = {
        Voice: !isNaN(month_avg.Voice/month_amount) ? month_avg.Voice/month_amount : null,
        SMS: !isNaN(month_avg.SMS/month_amount) ? month_avg.SMS/month_amount : null,
        MMS: !isNaN(month_avg.MMS/month_amount) ? month_avg.MMS/month_amount : null,
        Internet: !isNaN(month_avg.Internet/month_amount) ? month_avg.Internet/month_amount : null
      }
      let temp_chart = JSON.parse(JSON.stringify(state.prototype.all_service))
      let provider_name = formdata.type_providers == 'group' ? formdata.provider_group.group_name_th : formdata.provider_list.brand_name
      let provider_color = formdata.type_providers == 'group' ? formdata.provider_group.group_color_code : formdata.provider_list.provider_color
      temp_chart.title.text = 'อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet ของผู้ให้บริการโทรศัพท์เคลื่อนที่' + (' เดือน' + month_th[moment(start).month()] + ' ปี พ.ศ. ' + moment(start).add(543, 'y').year()) + ' โดยเปรียบเทียบกับอัตราอ้างอิงในการกำกับดูแล'
      temp_chart.xAxis.categories = ['Voice (บาท/นาที)','SMS (บาท/ข้อความ)','MMS (บาท/ข้อความ)','Internet (บาท/MB)']
      temp_chart.xAxis.min = 0
      temp_chart.xAxis.max = 3
      temp_chart.xAxis.showFirstLabel = true
      temp_chart.xAxis.showLastLabel = true
      if (!(final.Voice == null && final.SMS == null && final.MMS == null && final.Internet == null)) {
        if(!formdata.weighting){
          temp_chart.series = [{
            name: provider_name,
            // data: [final.Voice,final.SMS,final.MMS,final.Internet],
            data: [{y: final.Voice, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: final.SMS, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: final.MMS, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)},
              {y: final.Internet, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: provider_color,
            pointPadding: 0,
            pointPlacement: 0,
            dataLabels: {
              enabled: true,
              formatter: function(){
                return this.point.label >= 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'Ceiling',
            data: [{y: service_regulate.voice_service_rate > 0 && final.Voice > 0 ? service_regulate.voice_service_rate : null, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: service_regulate.sms_service_rate > 0 && final.SMS > 0 ? service_regulate.sms_service_rate : null, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: service_regulate.mms_service_rate > 0 && final.MMS > 0 ? service_regulate.mms_service_rate : null, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)}, 
              {y: service_regulate.internet_service_rate > 0 && final.Internet > 0 ? service_regulate.internet_service_rate : null, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: hexToRgba(provider_color, 0.5),
            pointPadding: 0,
            pointPlacement: 0,
            dataLabels: {
              enabled: true,
              formatter: function(){
                return this.point.label < 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          }]
        } else {
          let weight_final = weighting(formdata, obj.weightingData.promotion, obj.weightingData.provider_id_list, propotion, start)
          temp_chart.series = [{
            name: provider_name,
            // data: [final.Voice,final.SMS,final.MMS,final.Internet],
            data: [{y: final.Voice, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: final.SMS, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: final.MMS, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)},
              {y: final.Internet, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: provider_color,
            pointPadding: 0.3,
            pointPlacement: -0.2,
            dataLabels: {
              // enabled: false
              enabled: true,
              formatter: function(){
                return this.point.label >= 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'Ceiling',
            data: [{y: service_regulate.voice_service_rate > 0 && final.Voice > 0 ? service_regulate.voice_service_rate : null, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: service_regulate.sms_service_rate > 0 && final.SMS > 0 ? service_regulate.sms_service_rate : null, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: service_regulate.mms_service_rate > 0 && final.MMS > 0 ? service_regulate.mms_service_rate : null, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)}, 
              {y: service_regulate.internet_service_rate > 0 && final.Internet > 0 ? service_regulate.internet_service_rate : null, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: hexToRgba(provider_color, 0.5),
            pointPadding: 0.3,
            pointPlacement: -0.2,
            dataLabels: {
              enabled: true,
              formatter: function(){
                return this.point.label < 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'ค่าเฉลี่ยถ่วงน้ำหนัก(ของตลาด)',
            data: [weight_final.Voice, weight_final.SMS, weight_final.MMS, weight_final.Internet],
            color: '#ffcc00',
            pointPadding: 0.3,
            pointPlacement: 0.2,
            dataLabels: {
              enabled: true,
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          }]
        }
      }
      temp_chart.tooltip.formatter = function () {
        return this.points.reduce(function (s, point) {
            return s + '<br/>' + point.series.name + ': ' +
                point.y.toFixed(2);
        }, '<b>' + this.x + '</b>');
      }
      state.charts.push(temp_chart)
    }
    state.showChart = true
    state.loading = false
  },
  SET_ALL_SERVICE_CHART_YEAR(state, obj){
    let formdata = obj.formdata
    let data = obj.querydata
    let propotion = obj.propotion
    let service_regulate = obj.service_regulate
    let provider_id_list = formdata.type_providers == 'group' ? JSON.parse('[' + formdata.provider_group.group_company_list.slice(1,-1) + ']') : [formdata.provider_list.id]
    for(let start_year = formdata.daterange[0], end_year = formdata.daterange[1]; start_year < end_year; start_year = moment(start_year).add(1, 'Y').format('YYYY-MM-DD')){
      let total_avg = {
        Voice: 0,
        SMS: 0,
        MMS: 0,
        Internet: 0
      }
      let total_amount = 0
      for(let start = moment(start_year)._d, end = moment(start_year).add(1, 'Y').subtract(1, 'd')._d; start < end; start = moment(start).add(1, 'M')._d){
        let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
        let month_avg = {
          Voice: 0,
          SMS: 0,
          MMS: 0,
          Internet: 0
        }
        let month_amount = 0
        for(let p = 0; p < provider_id_list.length; p++){
          let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
          let main = monthly_provider.filter(type => type.promotion_type == 'main')
          let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
          main = main.length > 0 ? main[0] : []
          ontop = ontop.length > 0 ? ontop[0] : []
          if(monthly_provider.length == 0) continue;
          if(moment(start).year() >= 2020){
            if((main.length != 0) && (ontop.length != 0)){
              if(ontop.vpm_amount != 0){
                month_avg.Voice += ((main.vpm_sum/main.vpm_amount)*(propotion.main/100)) + ((ontop.vpm_sum/ontop.vpm_amount)*(propotion.ontop/100))
              } else {
                month_avg.Voice += main.vpm_sum/main.vpm_amount
              }
              if(ontop.sms_amount != 0){
                month_avg.SMS += ((main.sms_sum/main.sms_amount)*(propotion.main/100)) + ((ontop.sms_sum/ontop.sms_amount)*(propotion.ontop/100))
              } else {
                month_avg.SMS += main.sms_sum/main.sms_amount
              }
              if(ontop.mms_amount != 0){
                month_avg.MMS += ((main.mms_sum/main.mms_amount)*(propotion.main/100)) + ((ontop.mms_sum/ontop.mms_amount)*(propotion.ontop/100))
              } else {
                month_avg.MMS += main.mms_sum/main.mms_amount
              }
              if(ontop.internet_amount != 0){
                month_avg.Internet += ((main.internet_sum/main.internet_amount)*(propotion.main/100)) + ((ontop.internet_sum/ontop.internet_amount)*(propotion.ontop/100))
              } else {
                month_avg.Internet += main.internet_sum/main.internet_amount
              }
              month_amount++
            } else if((main.length != 0) && (ontop.length == 0)){
              month_avg.Voice += main.vpm_sum/main.vpm_amount
              month_avg.SMS += main.sms_sum/main.sms_amount
              month_avg.MMS += main.mms_sum/main.mms_amount
              month_avg.Internet += main.internet_sum/main.internet_amount
              month_amount++
            }
          } else {
            let temp_avg = monthly_fixed(monthly_provider)
            if (temp_avg.Voice != undefined) {
              month_avg.Voice += temp_avg.Voice
              month_avg.SMS += temp_avg.SMS
              month_avg.MMS += temp_avg.MMS
              month_avg.Internet += temp_avg.Internet
              month_amount++
            }
          }
        }
        if (month_amount != 0) {
          total_avg.Voice += month_avg.Voice/month_amount
          total_avg.SMS += month_avg.SMS/month_amount
          total_avg.MMS += month_avg.MMS/month_amount
          total_avg.Internet += month_avg.Internet/month_amount
          total_amount++;
        }
      }
      let final = {
        Voice: !isNaN(total_avg.Voice/total_amount) ? total_avg.Voice/total_amount : null,
        SMS: !isNaN(total_avg.SMS/total_amount) ? total_avg.SMS/total_amount : null,
        MMS: !isNaN(total_avg.MMS/total_amount) ? total_avg.MMS/total_amount : null,
        Internet: !isNaN(total_avg.Internet/total_amount) ? total_avg.Internet/total_amount : null
      }
      let temp_chart = JSON.parse(JSON.stringify(state.prototype.all_service))
      let provider_name = formdata.type_providers == 'group' ? formdata.provider_group.group_name_th : formdata.provider_list.brand_name
      let provider_color = formdata.type_providers == 'group' ? formdata.provider_group.group_color_code : formdata.provider_list.provider_color
      temp_chart.title.text = 'อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet ของผู้ให้บริการโทรศัพท์เคลื่อนที่' + (' ปี พ.ศ. ' + moment(start_year).add(543, 'y').year()) + ' โดยเปรียบเทียบกับอัตราอ้างอิงในการกำกับดูแล'
      temp_chart.xAxis.categories = ['Voice (บาท/นาที)','SMS (บาท/ข้อความ)','MMS (บาท/ข้อความ)','Internet (บาท/MB)']
      temp_chart.xAxis.min = 0
      temp_chart.xAxis.max = 3
      temp_chart.xAxis.showFirstLabel = true
      temp_chart.xAxis.showLastLabel = true
      if (!(final.Voice == null && final.SMS == null && final.MMS == null && final.Internet == null)) {
        if(!formdata.weighting){
          temp_chart.series = [{
            name: provider_name,
            // data: [final.Voice,final.SMS,final.MMS,final.Internet],
            data: [{y: final.Voice, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: final.SMS, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: final.MMS, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)},
              {y: final.Internet, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: provider_color,
            pointPadding: 0,
            pointPlacement: 0,
            dataLabels: {
              // enabled: false
              enabled: true,
              formatter: function(){
                return this.point.label >= 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'Ceiling',
            data: [{y: service_regulate.voice_service_rate > 0 && final.Voice > 0 ? service_regulate.voice_service_rate : null, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: service_regulate.sms_service_rate > 0 && final.SMS > 0 ? service_regulate.sms_service_rate : null, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: service_regulate.mms_service_rate > 0 && final.MMS > 0 ? service_regulate.mms_service_rate : null, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)}, 
              {y: service_regulate.internet_service_rate > 0 && final.Internet > 0 ? service_regulate.internet_service_rate : null, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: hexToRgba(provider_color, 0.5),
            pointPadding: 0,
            pointPlacement: 0,
            dataLabels: {
              enabled: true,
              formatter: function(){
                return this.point.label < 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          }]
        } else {
          let weight_final = weighting_year(formdata, obj.weightingData.promotion, obj.weightingData.provider_id_list, propotion, start_year)
          temp_chart.series = [{
            name: provider_name,
            // data: [final.Voice,final.SMS,final.MMS,final.Internet],
            data: [{y: final.Voice, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: final.SMS, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: final.MMS, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)},
              {y: final.Internet, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: provider_color,
            pointPadding: 0.3,
            pointPlacement: -0.2,
            dataLabels: {
              // enabled: false
              enabled: true,
              formatter: function(){
                return this.point.label >= 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'Ceiling',
            data: [{y: service_regulate.voice_service_rate > 0 && final.Voice > 0 ? service_regulate.voice_service_rate : null, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: service_regulate.sms_service_rate > 0 && final.SMS > 0 ? service_regulate.sms_service_rate : null, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: service_regulate.mms_service_rate > 0 && final.MMS > 0 ? service_regulate.mms_service_rate : null, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)}, 
              {y: service_regulate.internet_service_rate > 0 && final.Internet > 0 ? service_regulate.internet_service_rate : null, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: hexToRgba(provider_color, 0.5),
            pointPadding: 0.3,
            pointPlacement: -0.2,
            dataLabels: {
              enabled: true,
              formatter: function(){
                return this.point.label < 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'ค่าเฉลี่ยถ่วงน้ำหนัก(ของตลาด)',
            data: [weight_final.Voice, weight_final.SMS, weight_final.MMS, weight_final.Internet],
            color: '#ffcc00',
            pointPadding: 0.3,
            pointPlacement: 0.2,
            dataLabels: {
              enabled: true,
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          }]
        }
      }
      temp_chart.tooltip.formatter = function () {
        return this.points.reduce(function (s, point) {
            return s + '<br/>' + point.series.name + ': ' +
                point.y.toFixed(2);
        }, '<b>' + this.x + '</b>');
      }
      state.charts.push(temp_chart)
    }
    state.showChart = true
    state.loading = false
  },
  SET_ALL_SERVICE_CHART_QUARTER(state, obj){
    let formdata = obj.formdata
    let data = obj.querydata
    let propotion = obj.propotion
    let service_regulate = obj.service_regulate
    let provider_id_list = formdata.type_providers == 'group' ? JSON.parse('[' + formdata.provider_group.group_company_list.slice(1,-1) + ']') : [formdata.provider_list.id]
    for(let start_quarter = formdata.daterange[0], end_quarter = formdata.daterange[1]; start_quarter < end_quarter; start_quarter = moment(start_quarter).add(3, 'M').format('YYYY-MM-DD')){
      let total_avg = {
        Voice: 0,
        SMS: 0,
        MMS: 0,
        Internet: 0
      }
      let total_amount = 0
      for(let start = moment(start_quarter)._d, end = moment(start_quarter).add(3, 'M').subtract(1, 'd')._d; start < end; start = moment(start).add(1, 'M')._d){
        let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
        let month_avg = {
          Voice: 0,
          SMS: 0,
          MMS: 0,
          Internet: 0
        }
        let month_amount = 0
        for(let p = 0; p < provider_id_list.length; p++){
          let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
          let main = monthly_provider.filter(type => type.promotion_type == 'main')
          let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
          main = main.length > 0 ? main[0] : []
          ontop = ontop.length > 0 ? ontop[0] : []
          if(monthly_provider.length == 0) continue;
          if(moment(start).year() >= 2020){
            if((main.length != 0) && (ontop.length != 0)){
              if(ontop.vpm_amount != 0){
                month_avg.Voice += ((main.vpm_sum/main.vpm_amount)*(propotion.main/100)) + ((ontop.vpm_sum/ontop.vpm_amount)*(propotion.ontop/100))
              } else {
                month_avg.Voice += main.vpm_sum/main.vpm_amount
              }
              if(ontop.sms_amount != 0){
                month_avg.SMS += ((main.sms_sum/main.sms_amount)*(propotion.main/100)) + ((ontop.sms_sum/ontop.sms_amount)*(propotion.ontop/100))
              } else {
                month_avg.SMS += main.sms_sum/main.sms_amount
              }
              if(ontop.mms_amount != 0){
                month_avg.MMS += ((main.mms_sum/main.mms_amount)*(propotion.main/100)) + ((ontop.mms_sum/ontop.mms_amount)*(propotion.ontop/100))
              } else {
                month_avg.MMS += main.mms_sum/main.mms_amount
              }
              if(ontop.internet_amount != 0){
                month_avg.Internet += ((main.internet_sum/main.internet_amount)*(propotion.main/100)) + ((ontop.internet_sum/ontop.internet_amount)*(propotion.ontop/100))
              } else {
                month_avg.Internet += main.internet_sum/main.internet_amount
              }
              month_amount++
            } else if((main.length != 0) && (ontop.length == 0)){
              month_avg.Voice += main.vpm_sum/main.vpm_amount
              month_avg.SMS += main.sms_sum/main.sms_amount
              month_avg.MMS += main.mms_sum/main.mms_amount
              month_avg.Internet += main.internet_sum/main.internet_amount
              month_amount++
            }
          } else {
            let temp_avg = monthly_fixed(monthly_provider)
            if (temp_avg.Voice != undefined) {
              month_avg.Voice += temp_avg.Voice
              month_avg.SMS += temp_avg.SMS
              month_avg.MMS += temp_avg.MMS
              month_avg.Internet += temp_avg.Internet
              month_amount++
            }
          }
        }
        if (month_amount != 0) {
          total_avg.Voice += month_avg.Voice/month_amount
          total_avg.SMS += month_avg.SMS/month_amount
          total_avg.MMS += month_avg.MMS/month_amount
          total_avg.Internet += month_avg.Internet/month_amount
          total_amount++;
        }
      }
      let final = {
        Voice: !isNaN(total_avg.Voice/total_amount) ? total_avg.Voice/total_amount : null,
        SMS: !isNaN(total_avg.SMS/total_amount) ? total_avg.SMS/total_amount : null,
        MMS: !isNaN(total_avg.MMS/total_amount) ? total_avg.MMS/total_amount : null,
        Internet: !isNaN(total_avg.Internet/total_amount) ? total_avg.Internet/total_amount : null
      }
      let temp_chart = JSON.parse(JSON.stringify(state.prototype.all_service))
      let provider_name = formdata.type_providers == 'group' ? formdata.provider_group.group_name_th : formdata.provider_list.brand_name
      let provider_color = formdata.type_providers == 'group' ? formdata.provider_group.group_color_code : formdata.provider_list.provider_color
      temp_chart.title.text = 'อัตราค่าบริการเฉลี่ยของบริการประเภทเสียง บริการ SMS/MMS และบริการ Internet ของผู้ให้บริการโทรศัพท์เคลื่อนที่' + (' ในไตรมาสที่ ' + moment(start_quarter).quarter() + ' ปี พ.ศ. ' + moment(start_quarter).add(543, 'y').year()) + ' โดยเปรียบเทียบกับอัตราอ้างอิงในการกำกับดูแล'
      temp_chart.xAxis.categories = ['Voice (บาท/นาที)','SMS (บาท/ข้อความ)','MMS (บาท/ข้อความ)','Internet (บาท/MB)']
      temp_chart.xAxis.min = 0
      temp_chart.xAxis.max = 3
      temp_chart.xAxis.showFirstLabel = true
      temp_chart.xAxis.showLastLabel = true
      if (!(final.Voice == null && final.SMS == null && final.MMS == null && final.Internet == null)) {
        if(!formdata.weighting){
          temp_chart.series = [{
            name: provider_name,
            // data: [final.Voice,final.SMS,final.MMS,final.Internet],
            data: [{y: final.Voice, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: final.SMS, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: final.MMS, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)},
              {y: final.Internet, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: provider_color,
            pointPadding: 0,
            pointPlacement: 0,
            dataLabels: {
              // enabled: false
              enabled: true,
              formatter: function(){
                return this.point.label >= 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'Ceiling',
            data: [{y: service_regulate.voice_service_rate > 0 && final.Voice > 0 ? service_regulate.voice_service_rate : null, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: service_regulate.sms_service_rate > 0 && final.SMS > 0 ? service_regulate.sms_service_rate : null, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: service_regulate.mms_service_rate > 0 && final.MMS > 0 ? service_regulate.mms_service_rate : null, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)}, 
              {y: service_regulate.internet_service_rate > 0 && final.Internet > 0 ? service_regulate.internet_service_rate : null, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: hexToRgba(provider_color, 0.5),
            pointPadding: 0,
            pointPlacement: 0,
            dataLabels: {
              enabled: true,
              formatter: function(){
                return this.point.label < 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          }]
        } else {
          let weight_final = weighting_quarter(formdata, obj.weightingData.promotion, obj.weightingData.provider_id_list, propotion, start_quarter)
          temp_chart.series = [{
            name: provider_name,
            // data: [final.Voice,final.SMS,final.MMS,final.Internet],
            data: [{y: final.Voice, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: final.SMS, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: final.MMS, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)},
              {y: final.Internet, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: provider_color,
            pointPadding: 0.3,
            pointPlacement: -0.2,
            dataLabels: {
              // enabled: false
              enabled: true,
              formatter: function(){
                return this.point.label >= 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'Ceiling',
            data: [{y: service_regulate.voice_service_rate > 0 && final.Voice > 0 ? service_regulate.voice_service_rate : null, label: (((final.Voice - service_regulate.voice_service_rate)/ service_regulate.voice_service_rate)*100)},
              {y: service_regulate.sms_service_rate > 0 && final.SMS > 0 ? service_regulate.sms_service_rate : null, label: (((final.SMS - service_regulate.sms_service_rate)/ service_regulate.sms_service_rate)*100)},
              {y: service_regulate.mms_service_rate > 0 && final.MMS > 0 ? service_regulate.mms_service_rate : null, label: (((final.MMS - service_regulate.mms_service_rate)/ service_regulate.mms_service_rate)*100)}, 
              {y: service_regulate.internet_service_rate > 0 && final.Internet > 0 ? service_regulate.internet_service_rate : null, label: (((final.Internet - service_regulate.internet_service_rate)/ service_regulate.internet_service_rate)*100)}],
            color: hexToRgba(provider_color, 0.5),
            pointPadding: 0.3,
            pointPlacement: -0.2,
            dataLabels: {
              enabled: true,
              formatter: function(){
                return this.point.label < 0 ? this.point.label.toFixed(2) + '%' : ''
              },
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          },{
            name: 'ค่าเฉลี่ยถ่วงน้ำหนัก(ของตลาด)',
            data: [weight_final.Voice, weight_final.SMS, weight_final.MMS, weight_final.Internet],
            color: '#ffcc00',
            pointPadding: 0.3,
            pointPlacement: 0.2,
            dataLabels: {
              enabled: true,
              overflow: "allow",
              crop: false,
              allowOverlap: true
            }
          }]
        }
      }
      temp_chart.tooltip.formatter = function () {
        return this.points.reduce(function (s, point) {
            return s + '<br/>' + point.series.name + ': ' +
                point.y.toFixed(2);
        }, '<b>' + this.x + '</b>');
      }
      state.charts.push(temp_chart)
    }
    state.showChart = true
    state.loading = false
  },
  SET_SERVICE_CHART(state, obj){
    let formdata = obj.formdata
    let service_type = formdata.service_type
    let data = obj.querydata
    let propotion = obj.propotion
    let service_regulate = obj.service_regulate
    let provider_id_list = formdata.type_providers == 'group' ? JSON.parse('[' + formdata.provider_group.group_company_list.slice(1,-1) + ']') : [formdata.provider_list.id]
    let total_avg = {
      Voice: [],
      SMS: [],
      MMS: [],
      Internet: []
    }
    let temp_category = []
    for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
      let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
      let month_avg = {
        Voice: 0,
        SMS: 0,
        MMS: 0,
        Internet: 0
      }
      let month_amount = 0
      temp_category.push(month_th_abbreviation[moment(start).month()] + moment(start).add(543, 'y').subtract(2500, 'y').year())
      for(let p = 0; p < provider_id_list.length; p++){
        let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
        let main = monthly_provider.filter(type => type.promotion_type == 'main')
        let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
        main = main.length > 0 ? main[0] : []
        ontop = ontop.length > 0 ? ontop[0] : []
        if(monthly_provider.length == 0) continue;
        month_amount++
        if(moment(start).year() >= 2020){
          if((main.length != 0) && (ontop.length != 0)){
            if(ontop[service_amount[service_type]] != 0){
              month_avg[service_type] += ((main[service_sum[service_type]]/main[service_amount[service_type]])*(propotion.main/100)) + ((ontop[service_sum[service_type]]/ontop[service_amount[service_type]])*(propotion.ontop/100))
            } else {
              month_avg[service_type] += main[service_sum[service_type]]/main[service_amount[service_type]]
            }
          } else if((main.length != 0) && (ontop.length == 0)){
            month_avg[service_type] += main[service_sum[service_type]]/main[service_amount[service_type]]
          }
        } else {
          let temp_avg = monthly_fixed(monthly_provider)
          month_avg[service_type] += temp_avg[service_type]
        }
      }
      if (month_amount != 0) {
        total_avg[service_type].push(month_avg[service_type]/month_amount)
      } else {
        total_avg[service_type].push(null)
      }
    }
    let ceiling = []
    for(let i = 0; i < total_avg[service_type].length; i++){
      if(total_avg[service_type][i] != null) {
        ceiling.push(service_regulate[service_rate[service_type]])
      } else {
        ceiling.push(null)
      }
    }
    let temp_chart = JSON.parse(JSON.stringify(state.prototype.all_service))
    let provider_name = formdata.type_providers == 'group' ? formdata.provider_group.group_name_th : formdata.provider_list.brand_name
    let provider_color = formdata.type_providers == 'group' ? formdata.provider_group.group_color_code : formdata.provider_list.provider_color
    temp_chart.title.text = formdata.title
    temp_chart.xAxis.categories = temp_category
    temp_chart.yAxis.title.text = labelAsset[service_type]
    if(total_avg[formdata.service_type].length == 1) {
      temp_chart.xAxis.min = -0.5
      temp_chart.xAxis.max = 0.5
      temp_chart.xAxis.showFirstLabel = false
      temp_chart.xAxis.showLastLabel = false
    } else {
      temp_chart.xAxis.min = 0
      temp_chart.xAxis.max = total_avg[formdata.service_type].length - 1
      temp_chart.xAxis.showFirstLabel = true
      temp_chart.xAxis.showLastLabel = true
    }
    if(!formdata.weighting){
      temp_chart.series = [{
        name: provider_name,
        data: total_avg[formdata.service_type],
        color: provider_color,
        pointPadding: 0.3,
        pointPlacement: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      },{
        name: 'Ceiling',
        data: ceiling,
        color: hexToRgba(provider_color, 0.5),
        pointPadding: 0.3,
        pointPlacement: 0,
        dataLabels: {
          enabled: false
        }
      }]
    } else {
      let weight_final = month_weighting(formdata, obj.weightingData.promotion, obj.weightingData.provider_id_list, propotion)
      temp_chart.series = [{
        name: provider_name,
        data: total_avg[formdata.service_type],
        color: provider_color,
        pointPadding: 0.3,
        pointPlacement: -0.2,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      },{
        name: 'Ceiling',
        data: ceiling,
        color: hexToRgba(provider_color, 0.5),
        pointPadding: 0.3,
        pointPlacement: -0.2,
        dataLabels: {
          enabled: false
        }
      },{
        name: 'ค่าเฉลี่ยถ่วงน้ำหนัก(ของตลาด)',
        data: weight_final,
        color: '#ffcc00',
        pointPadding: 0.3,
        pointPlacement: 0.2,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      }]
    }
    temp_chart.tooltip.formatter = function () {
      return this.points.reduce(function (s, point) {
          return s + '<br/>' + point.series.name + ': ' +
              point.y.toFixed(2);
      }, '<b>' + this.x + '</b>');
    }
    state.charts.push(temp_chart)
    state.showChart = true
    state.loading = false
  },
  SET_SERVICE_CHART_YEAR(state, obj){
    let formdata = obj.formdata
    let service_type = formdata.service_type
    let data = obj.querydata
    let propotion = obj.propotion
    let service_regulate = obj.service_regulate
    let provider_id_list = formdata.type_providers == 'group' ? JSON.parse('[' + formdata.provider_group.group_company_list.slice(1,-1) + ']') : [formdata.provider_list.id]
    let total_avg = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    let total_amount = 0
    let final = {
      Voice: [],
      SMS: [],
      MMS: [],
      Internet: []
    }
    let temp_category = []
    for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(1, 'Y').format('YYYY-MM-DD')){
      let temp_year = moment(start).year()
      temp_category.push('ปี พ.ศ. ' + moment(start).add(543, 'y').year())
      total_avg = {
        Voice: 0,
        SMS: 0,
        MMS: 0,
        Internet: 0
      }
      total_amount = 0
      for(let start = moment(temp_year + '-01-01').format('YYYY-MM-DD'), end = moment(temp_year + '-12-31').format('YYYY-MM-DD'); start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
        let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
        let month_avg = {
          Voice: 0,
          SMS: 0,
          MMS: 0,
          Internet: 0
        }
        let month_amount = 0
        for(let p = 0; p < provider_id_list.length; p++){
          let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
          let main = monthly_provider.filter(type => type.promotion_type == 'main')
          let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
          main = main.length > 0 ? main[0] : []
          ontop = ontop.length > 0 ? ontop[0] : []
          if(monthly_provider.length == 0) continue;
          month_amount++
          if(moment(start).year() >= 2020){
            if((main.length != 0) && (ontop.length != 0)){
              if(ontop[service_amount[service_type]] != 0){
                month_avg[service_type] += ((main[service_sum[service_type]]/main[service_amount[service_type]])*(propotion.main/100)) + ((ontop[service_sum[service_type]]/ontop[service_amount[service_type]])*(propotion.ontop/100))
              } else {
                month_avg[service_type] += main[service_sum[service_type]]/main[service_amount[service_type]]
              }
            } else if((main.length != 0) && (ontop.length == 0)){
              month_avg[service_type] += main[service_sum[service_type]]/main[service_amount[service_type]]
            }
          } else {
            let temp_avg = monthly_fixed(monthly_provider)
            month_avg[service_type] += temp_avg[service_type]
          }
        }
        if (month_amount != 0) {
          total_avg[service_type] += (month_avg[service_type]/month_amount)
          total_amount++;
        }
      }
      final[service_type].push(!isNaN(total_avg[service_type]/total_amount) ? total_avg[service_type]/total_amount : null)
    }
    // let diff_percent = final[formdata.service_type].map(value => {return {y:service_regulate[service_rate[service_type]], label:(((value-service_regulate[service_rate[formdata.service_type]])/service_regulate[service_rate[formdata.service_type]])*100)}})
    // diff_percent = diff_percent.map(data => {return data.label != -100 ? data : {y: null, label: ''}})
    let ceiling = []
    for(let i = 0; i < final[service_type].length; i++){
      if(final[service_type][i] != null) {
        ceiling.push(service_regulate[service_rate[service_type]])
      } else {
        ceiling.push(null)
      }
    }
    let temp_chart = JSON.parse(JSON.stringify(state.prototype.one_service))
    let provider_name = formdata.type_providers == 'group' ? formdata.provider_group.group_name_th : formdata.provider_list.brand_name
    let provider_color = formdata.type_providers == 'group' ? formdata.provider_group.group_color_code : formdata.provider_list.provider_color
    temp_chart.title.text = formdata.title
    temp_chart.xAxis.categories = temp_category
    temp_chart.yAxis.title.text = labelAsset[service_type]
    if(final[formdata.service_type].length == 1) {
      temp_chart.xAxis.min = -0.5
      temp_chart.xAxis.max = 0.5
      temp_chart.xAxis.showFirstLabel = false
      temp_chart.xAxis.showLastLabel = false
    } else {
      temp_chart.xAxis.min = 0
      temp_chart.xAxis.max = final[formdata.service_type].length - 1
      temp_chart.xAxis.showFirstLabel = true
      temp_chart.xAxis.showLastLabel = true
    }
    if(!formdata.weighting){
      temp_chart.series = [{
        name: provider_name,
        data: final[formdata.service_type],
        color: provider_color,
        pointPadding: 0.3,
        pointPlacement: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      },{
        name: 'Ceiling',
        data: ceiling,
        color: hexToRgba(provider_color, 0.5),
        pointPadding: 0.3,
        pointPlacement: 0,
        dataLabels: {
          enabled: false
        }
      }]
    } else {
      let weight_final = year_weighting(formdata, obj.weightingData.promotion, obj.weightingData.provider_id_list, propotion)
      temp_chart.series = [{
        name: provider_name,
        data: final[formdata.service_type],
        color: provider_color,
        pointPadding: 0.3,
        pointPlacement: -0.2,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      },{
        name: 'Ceiling',
        data: ceiling,
        color: hexToRgba(provider_color, 0.5),
        pointPadding: 0.3,
        pointPlacement: -0.2,
        dataLabels: {
          enabled: false
        }
      },{
        name: 'ค่าเฉลี่ยถ่วงน้ำหนัก(ของตลาด)',
        data: weight_final,
        color: '#ffcc00',
        pointPadding: 0.3,
        pointPlacement: 0.2,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      }]
    }
    temp_chart.tooltip.formatter = function () {
      return this.points.reduce(function (s, point) {
          return s + '<br/>' + point.series.name + ': ' +
              point.y.toFixed(2);
      }, '<b>' + this.x + '</b>');
    },
    state.charts.push(temp_chart)
    state.showChart = true
    state.loading = false
  },
  SET_SERVICE_CHART_QUARTER(state, obj){
    let formdata = obj.formdata
    let service_type = formdata.service_type
    let data = obj.querydata
    let propotion = obj.propotion
    let service_regulate = obj.service_regulate
    let provider_id_list = formdata.type_providers == 'group' ? JSON.parse('[' + formdata.provider_group.group_company_list.slice(1,-1) + ']') : [formdata.provider_list.id]
    let total_avg = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    let total_amount = 0
    let final = {
      Voice: [],
      SMS: [],
      MMS: [],
      Internet: []
    }
    let temp_category = []
    for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(3, 'M').format('YYYY-MM-DD')){
      let quarter = moment(start).quarter()
      let temp_year = moment(start).year()
      temp_category.push(moment(start).quarter() + 'Q' + moment(start).add(543, 'y').year())
      total_avg = {
        Voice: 0,
        SMS: 0,
        MMS: 0,
        Internet: 0
      }
      total_amount = 0
      for(let start = moment(temp_year + '-01-01').add((quarter-1)*3, 'M').format('YYYY-MM-DD'), end = moment(temp_year + '-01-01').add((quarter*3),'M').subtract(1, 'd').format('YYYY-MM-DD'); start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
        let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
        let month_avg = {
          Voice: 0,
          SMS: 0,
          MMS: 0,
          Internet: 0
        }
        let month_amount = 0
        for(let p = 0; p < provider_id_list.length; p++){
          let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
          let main = monthly_provider.filter(type => type.promotion_type == 'main')
          let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
          main = main.length > 0 ? main[0] : []
          ontop = ontop.length > 0 ? ontop[0] : []
          if(monthly_provider.length == 0) continue;
          month_amount++
          if(moment(start).year() >= 2020){
            if((main.length != 0) && (ontop.length != 0)){
              if(ontop[service_amount[service_type]] != 0){
                month_avg[service_type] += ((main[service_sum[service_type]]/main[service_amount[service_type]])*(propotion.main/100)) + ((ontop[service_sum[service_type]]/ontop[service_amount[service_type]])*(propotion.ontop/100))
              } else {
                month_avg[service_type] += main[service_sum[service_type]]/main[service_amount[service_type]]
              }
            } else if((main.length != 0) && (ontop.length == 0)){
              month_avg[service_type] += main[service_sum[service_type]]/main[service_amount[service_type]]
            }
          } else {
            let temp_avg = monthly_fixed(monthly_provider)
            month_avg[service_type] += temp_avg[service_type]
          }
        }
        if (month_amount != 0) {
          total_avg[service_type] += (month_avg[service_type]/month_amount)
          total_amount++;
        }
      }
      final[service_type].push(!isNaN(total_avg[service_type]/total_amount) ? total_avg[service_type]/total_amount : null)
    }
    // let diff_percent = final[formdata.service_type].map(value => {return {y:service_regulate[service_rate[service_type]], label:(((value-service_regulate[service_rate[formdata.service_type]])/service_regulate[service_rate[formdata.service_type]])*100)}})
    // diff_percent = diff_percent.map(data => {return data.label != -100 ? data : {y: null, label: ''}})
    let ceiling = []
    for(let i = 0; i < final[service_type].length; i++){
      if(final[service_type][i] != null) {
        ceiling.push(service_regulate[service_rate[service_type]])
      } else {
        ceiling.push(null)
      }
    }
    let temp_chart = JSON.parse(JSON.stringify(state.prototype.one_service))
    let provider_name = formdata.type_providers == 'group' ? formdata.provider_group.group_name_th : formdata.provider_list.brand_name
    let provider_color = formdata.type_providers == 'group' ? formdata.provider_group.group_color_code : formdata.provider_list.provider_color
    temp_chart.title.text = formdata.title
    temp_chart.xAxis.categories = temp_category
    temp_chart.yAxis.title.text = labelAsset[service_type]
    if(final[formdata.service_type].length == 1) {
      temp_chart.xAxis.min = -0.5
      temp_chart.xAxis.max = 0.5
      temp_chart.xAxis.showFirstLabel = false
      temp_chart.xAxis.showLastLabel = false
    } else {
      temp_chart.xAxis.min = 0
      temp_chart.xAxis.max = final[formdata.service_type].length - 1
      temp_chart.xAxis.showFirstLabel = true
      temp_chart.xAxis.showLastLabel = true
    }
    if(!formdata.weighting){
      temp_chart.series = [{
        name: provider_name,
        data: final[formdata.service_type],
        color: provider_color,
        pointPadding: 0.3,
        pointPlacement: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      },{
        name: 'Ceiling',
        data: ceiling,
        color: hexToRgba(provider_color, 0.5),
        pointPadding: 0.3,
        pointPlacement: 0,
        dataLabels: {
          enabled: false
        }
      }]
    } else {
      let weight_final = quarter_weighting(formdata, obj.weightingData.promotion, obj.weightingData.provider_id_list, propotion)
      temp_chart.series = [{
        name: provider_name,
        data: final[formdata.service_type],
        color: provider_color,
        pointPadding: 0.3,
        pointPlacement: -0.2,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      },{
        name: 'Ceiling',
        data: ceiling,
        color: hexToRgba(provider_color, 0.5),
        pointPadding: 0.3,
        pointPlacement: -0.2,
        dataLabels: {
          enabled: false
        }
      },{
        name: 'ค่าเฉลี่ยถ่วงน้ำหนัก(ของตลาด)',
        data: weight_final,
        color: '#ffcc00',
        pointPadding: 0.3,
        pointPlacement: 0.2,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f}'
        }
      }]
    }
    temp_chart.tooltip.formatter = function () {
      return this.points.reduce(function (s, point) {
          return s + '<br/>' + point.series.name + ': ' +
              point.y.toFixed(2);
      }, '<b>' + this.x + '</b>');
    },
    state.charts.push(temp_chart)
    state.showChart = true
    state.loading = false
  },
  SET_SERVICE_RATE(state, obj) {
    state.service_rate_regulate = obj
  }
};

function monthly_fixed(obj){
  let service_type = {}
  for(let i = 0; i < obj.length; i++){
    service_type[obj[i].service_type] = obj[i].price_avg
  }
  return service_type
}

function LightenDarkenColor(col, amt) {
    var usePound = false;
    if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
    }
    var num = parseInt(col,16);
 
    var r = (num >> 16) + amt;
 
    if (r > 255) r = 255;
    else if  (r < 0) r = 0;
    var b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255) b = 255;
    else if  (b < 0) b = 0;
    var g = (num & 0x0000FF) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}

function hexToRgba(hex, opacity){
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  opacity = opacity ? opacity : 1
  return 'rgba(' + parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ',' + opacity + ')'
}

function regular_average(formdata, data, provider_id_list, propotion) {
  let total_avg = {
    Voice: 0,
    SMS: 0,
    MMS: 0,
    Internet: 0
  }
  let total_amount = 0
  for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
    let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
    let month_avg = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    let month_amount = 0
    for(let p = 0; p < provider_id_list.length; p++){
      let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
      let main = monthly_provider.filter(type => type.promotion_type == 'main')[0]
      let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')[0]
      if(monthly_provider.length == 0) continue;
      month_amount++
      if(moment(start).year() >= 2020){
        if((main.length != 0) && (ontop.length != 0)){
          if(ontop.vpm_amount != 0){
            month_avg.Voice += ((main.vpm_sum/main.vpm_amount)*(propotion.main/100)) + ((ontop.vpm_sum/ontop.vpm_amount)*(propotion.ontop/100))
          } else {
            month_avg.Voice += main.vpm_sum/main.vpm_amount
          }
          if(ontop.sms_amount != 0){
            month_avg.SMS += ((main.sms_sum/main.sms_amount)*(propotion.main/100)) + ((ontop.sms_sum/ontop.sms_amount)*(propotion.ontop/100))
          } else {
            month_avg.SMS += main.sms_sum/main.sms_amount
          }
          if(ontop.mms_amount != 0){
            month_avg.MMS += ((main.mms_sum/main.mms_amount)*(propotion.main/100)) + ((ontop.mms_sum/ontop.mms_amount)*(propotion.ontop/100))
          } else {
            month_avg.MMS += main.mms_sum/main.mms_amount
          }
          if(ontop.internet_amount != 0){
            month_avg.Internet += ((main.internet_sum/main.internet_amount)*(propotion.main/100)) + ((ontop.internet_sum/ontop.internet_amount)*(propotion.ontop/100))
          } else {
            month_avg.Internet += main.internet_sum/main.internet_amount
          }
        } else if((main.length != 0) && (ontop.length == 0)){
          month_avg.Voice += main.vpm_sum/main.vpm_amount
          month_avg.SMS += main.sms_sum/main.sms_amount
          month_avg.MMS += main.mms_sum/main.mms_amount
          month_avg.Internet += main.internet_sum/main.internet_amount
        }
      } else {
        let temp_avg = monthly_fixed(monthly_provider)
        month_avg.Voice += temp_avg.Voice
        month_avg.SMS += temp_avg.SMS
        month_avg.MMS += temp_avg.MMS
        month_avg.Internet += temp_avg.Internet
      }
    }
    if (month_amount != 0) {
      total_avg.Voice += month_avg.Voice/month_amount
      total_avg.SMS += month_avg.SMS/month_amount
      total_avg.MMS += month_avg.MMS/month_amount
      total_avg.Internet += month_avg.Internet/month_amount
      total_amount++;
    }
  }
  let final = {
    Voice: !isNaN(total_avg.Voice/total_amount) ? parseFloat((total_avg.Voice/total_amount).toFixed(2)) : null,
    SMS: !isNaN(total_avg.SMS/total_amount) ? parseFloat((total_avg.SMS/total_amount).toFixed(2)) : null,
    MMS: !isNaN(total_avg.MMS/total_amount) ? parseFloat((total_avg.MMS/total_amount).toFixed(2)) : null,
    Internet: !isNaN(total_avg.Internet/total_amount) ? parseFloat((total_avg.Internet/total_amount).toFixed(2)) : null
  }
  return final
}

function weighting(formdata, data, provider_id_list, propotion, monthly_regulate) {
  let total_avg = {
    Voice: 0,
    SMS: 0,
    MMS: 0,
    Internet: 0
  }
  let total_amount = {
    Voice: 0,
    SMS: 0,
    MMS: 0,
    Internet: 0
  }
  let temp_month = []
  // for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
    let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(monthly_regulate).format('YYYY-MM-DD')})
    let month_avg = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    let month_amount = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    for(let p = 0; p < provider_id_list.length; p++){
      let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
      let main = monthly_provider.filter(type => type.promotion_type == 'main')
      let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
      main = main.length > 0 ? main[0] : []
      ontop = ontop.length > 0 ? ontop[0] : []
      if(monthly_provider.length == 0) continue;
      if(moment(monthly_regulate).year() >= 2020){
        if((main.length != 0) && (ontop.length != 0)){
          if(ontop.vpm_amount != 0){
            month_amount.Voice += (main.vpm_amount + ontop.vpm_amount)
            month_avg.Voice += (((main.vpm_sum/main.vpm_amount)*(propotion.main/100)) + ((ontop.vpm_sum/ontop.vpm_amount)*(propotion.ontop/100))) * (main.vpm_amount + ontop.vpm_amount)
          } else {
            month_amount.Voice += main.vpm_amount
            month_avg.Voice += main.vpm_sum
          }
          if(ontop.sms_amount != 0){
            month_amount.SMS += (main.sms_amount + ontop.sms_amount)
            month_avg.SMS += (((main.sms_sum/main.sms_amount)*(propotion.main/100)) + ((ontop.sms_sum/ontop.sms_amount)*(propotion.ontop/100))) * (main.sms_amount + ontop.sms_amount)
          } else {
            month_amount.SMS += main.sms_amount
            month_avg.SMS += main.sms_sum
          }
          if(ontop.mms_amount != 0){
            month_amount.MMS += (main.mms_amount + ontop.mms_amount)
            month_avg.MMS += (((main.mms_sum/main.mms_amount)*(propotion.main/100)) + ((ontop.mms_sum/ontop.mms_amount)*(propotion.ontop/100))) * (main.mms_amount + ontop.mms_amount)
          } else {
            month_amount.MMS += main.mms_amount
            month_avg.MMS += main.mms_sum
          }
          if(ontop.internet_amount != 0){
            month_amount.Internet += (main.internet_amount + ontop.internet_amount)
            month_avg.Internet += (((main.internet_sum/main.internet_amount)*(propotion.main/100)) + ((ontop.internet_sum/ontop.internet_amount)*(propotion.ontop/100))) * (main.internet_amount + ontop.internet_amount)
          } else {
            month_amount.Internet += main.internet_amount
            month_avg.Internet += main.internet_sum
          }
        } else if((main.length != 0) && (ontop.length == 0)){
          month_avg.Voice += main.vpm_sum
          month_avg.SMS += main.sms_sum
          month_avg.MMS += main.mms_sum
          month_avg.Internet += main.internet_sum
          month_amount.Voice += main.vpm_amount
          month_amount.SMS += main.sms_amount
          month_amount.MMS += main.mms_amount
          month_amount.Internet += main.internet_amount
        }
      } else {
        let temp_avg = monthly_fixed(monthly_provider)
        month_avg.Voice += temp_avg.Voice
        month_avg.SMS += temp_avg.SMS
        month_avg.MMS += temp_avg.MMS
        month_avg.Internet += temp_avg.Internet
      }
    }
    if (month_amount.Voice != 0) {
      total_avg.Voice += (month_avg.Voice/month_amount.Voice)
      total_amount.Voice++;
    }
    if (month_amount.SMS != 0) {
      total_avg.SMS += (month_avg.SMS/month_amount.SMS)
      total_amount.SMS++;
    }
    if (month_amount.MMS != 0) {
      total_avg.MMS += (month_avg.MMS/month_amount.MMS)
      total_amount.MMS++;
    }
    if (month_amount.Internet != 0) {
      total_avg.Internet += (month_avg.Internet/month_amount.Internet)
      total_amount.Internet++;
    }
  let final = {
    Voice: !isNaN(total_avg.Voice/total_amount.Voice) ? parseFloat((total_avg.Voice/total_amount.Voice).toFixed(2)) : null,
    SMS: !isNaN(total_avg.SMS/total_amount.SMS) ? parseFloat((total_avg.SMS/total_amount.SMS).toFixed(2)) : null,
    MMS: !isNaN(total_avg.MMS/total_amount.MMS) ? parseFloat((total_avg.MMS/total_amount.MMS).toFixed(2)) : null,
    Internet: !isNaN(total_avg.Internet/total_amount.Internet) ? parseFloat((total_avg.Internet/total_amount.Internet).toFixed(2)) : null
  }
  return final
}

function weighting_year(formdata, data, provider_id_list, propotion, year) {
  let total_avg = {
    Voice: 0,
    SMS: 0,
    MMS: 0,
    Internet: 0
  }
  let total_amount = {
    Voice: 0,
    SMS: 0,
    MMS: 0,
    Internet: 0
  }
  let temp_month = []
  for(let start = moment(year)._d, end = moment(year).add(1, 'Y')._d; start < end; start = moment(start).add(1, 'M')._d){
    let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
    let month_avg = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    let month_amount = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    for(let p = 0; p < provider_id_list.length; p++){
      let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
      let main = monthly_provider.filter(type => type.promotion_type == 'main')
      let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
      main = main.length > 0 ? main[0] : []
      ontop = ontop.length > 0 ? ontop[0] : []
      if(monthly_provider.length == 0) continue;
      if(moment(start).year() >= 2020){
        if((main.length != 0) && (ontop.length != 0)){
          if(ontop.vpm_amount != 0){
            month_amount.Voice += (main.vpm_amount + ontop.vpm_amount)
            month_avg.Voice += (((main.vpm_sum/main.vpm_amount)*(propotion.main/100)) + ((ontop.vpm_sum/ontop.vpm_amount)*(propotion.ontop/100))) * (main.vpm_amount + ontop.vpm_amount)
          } else {
            month_amount.Voice += main.vpm_amount
            month_avg.Voice += main.vpm_sum
          }
          if(ontop.sms_amount != 0){
            month_amount.SMS += (main.sms_amount + ontop.sms_amount)
            month_avg.SMS += (((main.sms_sum/main.sms_amount)*(propotion.main/100)) + ((ontop.sms_sum/ontop.sms_amount)*(propotion.ontop/100))) * (main.sms_amount + ontop.sms_amount)
          } else {
            month_amount.SMS += main.sms_amount
            month_avg.SMS += main.sms_sum
          }
          if(ontop.mms_amount != 0){
            month_amount.MMS += (main.mms_amount + ontop.mms_amount)
            month_avg.MMS += (((main.mms_sum/main.mms_amount)*(propotion.main/100)) + ((ontop.mms_sum/ontop.mms_amount)*(propotion.ontop/100))) * (main.mms_amount + ontop.mms_amount)
          } else {
            month_amount.MMS += main.mms_amount
            month_avg.MMS += main.mms_sum
          }
          if(ontop.internet_amount != 0){
            month_amount.Internet += (main.internet_amount + ontop.internet_amount)
            month_avg.Internet += (((main.internet_sum/main.internet_amount)*(propotion.main/100)) + ((ontop.internet_sum/ontop.internet_amount)*(propotion.ontop/100))) * (main.internet_amount + ontop.internet_amount)
          } else {
            month_amount.Internet += main.internet_amount
            month_avg.Internet += main.internet_sum
          }
        } else if((main.length != 0) && (ontop.length == 0)){
          month_avg.Voice += main.vpm_sum
          month_avg.SMS += main.sms_sum
          month_avg.MMS += main.mms_sum
          month_avg.Internet += main.internet_sum
          month_amount.Voice += main.vpm_amount
          month_amount.SMS += main.sms_amount
          month_amount.MMS += main.mms_amount
          month_amount.Internet += main.internet_amount
        }
      } else {
        let temp_avg = monthly_fixed(monthly_provider)
        month_avg.Voice += temp_avg.Voice
        month_avg.SMS += temp_avg.SMS
        month_avg.MMS += temp_avg.MMS
        month_avg.Internet += temp_avg.Internet
      }
    }
    if (month_amount.Voice != 0) {
      total_avg.Voice += (month_avg.Voice/month_amount.Voice)
      total_amount.Voice++;
    }
    if (month_amount.SMS != 0) {
      total_avg.SMS += (month_avg.SMS/month_amount.SMS)
      total_amount.SMS++;
    }
    if (month_amount.MMS != 0) {
      total_avg.MMS += (month_avg.MMS/month_amount.MMS)
      total_amount.MMS++;
    }
    if (month_amount.Internet != 0) {
      total_avg.Internet += (month_avg.Internet/month_amount.Internet)
      total_amount.Internet++;
    }
    let test = {
      Voice: !isNaN(month_avg.Voice/month_amount.Voice) ? month_avg.Voice/month_amount.Voice : null,
      SMS: !isNaN(month_avg.SMS/month_amount.SMS) ? month_avg.SMS/month_amount.SMS : null,
      MMS: !isNaN(month_avg.MMS/month_amount.MMS) ? month_avg.MMS/month_amount.MMS : null,
      Internet: !isNaN(month_avg.Internet/month_amount.Internet) ? month_avg.Internet/month_amount.Internet : null
    }
    temp_month.push({
      monthly_regulate: moment(start).format('YYYY-MM-DD'),
      data: test
    })
  }
  let final = {
    Voice: !isNaN(total_avg.Voice/total_amount.Voice) ? parseFloat((total_avg.Voice/total_amount.Voice).toFixed(2)) : null,
    SMS: !isNaN(total_avg.SMS/total_amount.SMS) ? parseFloat((total_avg.SMS/total_amount.SMS).toFixed(2)) : null,
    MMS: !isNaN(total_avg.MMS/total_amount.MMS) ? parseFloat((total_avg.MMS/total_amount.MMS).toFixed(2)) : null,
    Internet: !isNaN(total_avg.Internet/total_amount.Internet) ? parseFloat((total_avg.Internet/total_amount.Internet).toFixed(2)) : null
  }
  return final
}

function weighting_quarter(formdata, data, provider_id_list, propotion, quarter) {
  let total_avg = {
    Voice: 0,
    SMS: 0,
    MMS: 0,
    Internet: 0
  }
  let total_amount = {
    Voice: 0,
    SMS: 0,
    MMS: 0,
    Internet: 0
  }
  let temp_month = []
  for(let start = moment(quarter)._d, end = moment(quarter).add(3, 'M')._d; start < end; start = moment(start).add(1, 'M')._d){
    let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
    let month_avg = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    let month_amount = {
      Voice: 0,
      SMS: 0,
      MMS: 0,
      Internet: 0
    }
    for(let p = 0; p < provider_id_list.length; p++){
      let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
      let main = monthly_provider.filter(type => type.promotion_type == 'main')
      let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')
      main = main.length > 0 ? main[0] : []
      ontop = ontop.length > 0 ? ontop[0] : []
      if(monthly_provider.length == 0) continue;
      if(moment(start).year() >= 2020){
        if((main.length != 0) && (ontop.length != 0)){
          if(ontop.vpm_amount != 0){
            month_amount.Voice += (main.vpm_amount + ontop.vpm_amount)
            month_avg.Voice += (((main.vpm_sum/main.vpm_amount)*(propotion.main/100)) + ((ontop.vpm_sum/ontop.vpm_amount)*(propotion.ontop/100))) * (main.vpm_amount + ontop.vpm_amount)
          } else {
            month_amount.Voice += main.vpm_amount
            month_avg.Voice += main.vpm_sum
          }
          if(ontop.sms_amount != 0){
            month_amount.SMS += (main.sms_amount + ontop.sms_amount)
            month_avg.SMS += (((main.sms_sum/main.sms_amount)*(propotion.main/100)) + ((ontop.sms_sum/ontop.sms_amount)*(propotion.ontop/100))) * (main.sms_amount + ontop.sms_amount)
          } else {
            month_amount.SMS += main.sms_amount
            month_avg.SMS += main.sms_sum
          }
          if(ontop.mms_amount != 0){
            month_amount.MMS += (main.mms_amount + ontop.mms_amount)
            month_avg.MMS += (((main.mms_sum/main.mms_amount)*(propotion.main/100)) + ((ontop.mms_sum/ontop.mms_amount)*(propotion.ontop/100))) * (main.mms_amount + ontop.mms_amount)
          } else {
            month_amount.MMS += main.mms_amount
            month_avg.MMS += main.mms_sum
          }
          if(ontop.internet_amount != 0){
            month_amount.Internet += (main.internet_amount + ontop.internet_amount)
            month_avg.Internet += (((main.internet_sum/main.internet_amount)*(propotion.main/100)) + ((ontop.internet_sum/ontop.internet_amount)*(propotion.ontop/100))) * (main.internet_amount + ontop.internet_amount)
          } else {
            month_amount.Internet += main.internet_amount
            month_avg.Internet += main.internet_sum
          }
        } else if((main.length != 0) && (ontop.length == 0)){
          month_avg.Voice += main.vpm_sum
          month_avg.SMS += main.sms_sum
          month_avg.MMS += main.mms_sum
          month_avg.Internet += main.internet_sum
          month_amount.Voice += main.vpm_amount
          month_amount.SMS += main.sms_amount
          month_amount.MMS += main.mms_amount
          month_amount.Internet += main.internet_amount
        }
      } else {
        let temp_avg = monthly_fixed(monthly_provider)
        month_avg.Voice += temp_avg.Voice
        month_avg.SMS += temp_avg.SMS
        month_avg.MMS += temp_avg.MMS
        month_avg.Internet += temp_avg.Internet
      }
    }
    if (month_amount.Voice != 0) {
      total_avg.Voice += (month_avg.Voice/month_amount.Voice)
      total_amount.Voice++;
    }
    if (month_amount.SMS != 0) {
      total_avg.SMS += (month_avg.SMS/month_amount.SMS)
      total_amount.SMS++;
    }
    if (month_amount.MMS != 0) {
      total_avg.MMS += (month_avg.MMS/month_amount.MMS)
      total_amount.MMS++;
    }
    if (month_amount.Internet != 0) {
      total_avg.Internet += (month_avg.Internet/month_amount.Internet)
      total_amount.Internet++;
    }
    let test = {
      Voice: !isNaN(month_avg.Voice/month_amount.Voice) ? month_avg.Voice/month_amount.Voice : null,
      SMS: !isNaN(month_avg.SMS/month_amount.SMS) ? month_avg.SMS/month_amount.SMS : null,
      MMS: !isNaN(month_avg.MMS/month_amount.MMS) ? month_avg.MMS/month_amount.MMS : null,
      Internet: !isNaN(month_avg.Internet/month_amount.Internet) ? month_avg.Internet/month_amount.Internet : null
    }
    temp_month.push({
      monthly_regulate: moment(start).format('YYYY-MM-DD'),
      data: test
    })
  }
  let final = {
    Voice: !isNaN(total_avg.Voice/total_amount.Voice) ? parseFloat((total_avg.Voice/total_amount.Voice).toFixed(2)) : null,
    SMS: !isNaN(total_avg.SMS/total_amount.SMS) ? parseFloat((total_avg.SMS/total_amount.SMS).toFixed(2)) : null,
    MMS: !isNaN(total_avg.MMS/total_amount.MMS) ? parseFloat((total_avg.MMS/total_amount.MMS).toFixed(2)) : null,
    Internet: !isNaN(total_avg.Internet/total_amount.Internet) ? parseFloat((total_avg.Internet/total_amount.Internet).toFixed(2)) : null
  }
  return final
}

function month_weighting(formdata, data, provider_id_list, propotion){
  let service_type =  formdata.service_type
  let final = []
  for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
      let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
      let month_avg = 0
      let month_amount = 0
      for(let p = 0; p < provider_id_list.length; p++){
        let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
        let main = monthly_provider.filter(type => type.promotion_type == 'main')[0]
        let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')[0]
        if(monthly_provider.length == 0) continue;
        if(moment(start).year() >= 2020){
          if((main.length != 0) && (ontop.length != 0)){
            if(ontop[service_amount[service_type]] != 0){
              month_avg += (((main[service_sum[service_type]]/main[service_amount[service_type]])*(propotion.main/100)) + ((ontop[service_sum[service_type]]/ontop[service_amount[service_type]])*(propotion.ontop/100))) * (main[service_amount[service_type]] + ontop[service_amount[service_type]])
              month_amount += (main[service_amount[service_type]] + ontop[service_amount[service_type]])
            } else {
              month_avg += main[service_sum[service_type]]
              month_amount += main[service_amount[service_type]]
            }
          } else if((main.length != 0) && (ontop.length == 0)){
            month_avg += main[service_sum[service_type]]
            month_amount += main[service_amount[service_type]]
          }
        } else {
          let temp_avg = monthly_fixed(monthly_provider)
          month_avg += temp_avg[service_type]
        }
      }
      if (month_amount != 0) {
        final.push(!isNaN(month_avg/month_amount) ? parseFloat((month_avg/month_amount).toFixed(2)) : null)
      } else {
        final.push(null)
      }
  }
  return final
}

function year_weighting(formdata, data, provider_id_list, propotion){
  let service_type =  formdata.service_type
  let total_avg = 0
  let total_amount = 0
  let final = []
  for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(1, 'Y').format('YYYY-MM-DD')){
    let temp_year = moment(start).year()
    total_avg = 0
    total_amount = 0
    for(let start = moment(temp_year + '-01-01').format('YYYY-MM-DD'), end = moment(temp_year + '-12-31').format('YYYY-MM-DD'); start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
      let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
      let month_avg = 0
      let month_amount = 0
      for(let p = 0; p < provider_id_list.length; p++){
        let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
        let main = monthly_provider.filter(type => type.promotion_type == 'main')[0]
        let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')[0]
        if(monthly_provider.length == 0) continue;
        if(moment(start).year() >= 2020){
          if((main.length != 0) && (ontop.length != 0)){
            if(ontop[service_amount[service_type]] != 0){
              month_avg += (((main[service_sum[service_type]]/main[service_amount[service_type]])*(propotion.main/100)) + ((ontop[service_sum[service_type]]/ontop[service_amount[service_type]])*(propotion.ontop/100))) * (main[service_amount[service_type]] + ontop[service_amount[service_type]])
              month_amount += (main[service_amount[service_type]] + ontop[service_amount[service_type]])
            } else {
              month_avg += main[service_sum[service_type]]
              month_amount += main[service_amount[service_type]]
            }
          } else if((main.length != 0) && (ontop.length == 0)){
            month_avg += main[service_sum[service_type]]
            month_amount += main[service_amount[service_type]]
          }
        } else {
          let temp_avg = monthly_fixed(monthly_provider)
          month_avg += temp_avg[service_type]
        }
      }
      if (month_amount != 0) {
        total_avg += (month_avg/month_amount)
        total_amount++;
      }
    }
    final.push(!isNaN(total_avg/total_amount) ? parseFloat((total_avg/total_amount).toFixed(2)) : null)
  }
  return final
}

function quarter_weighting(formdata, data, provider_id_list, propotion){
  let service_type =  formdata.service_type
  let total_avg = 0
  let total_amount = 0
  let final = []
  for(let start = formdata.daterange[0], end = formdata.daterange[1]; start < end; start = moment(start).add(3, 'M').format('YYYY-MM-DD')){
    let quarter = moment(start).quarter()
    let temp_year = moment(start).year()
    total_avg = 0
    total_amount = 0
    for(let start = moment(temp_year + '-01-01').add((quarter-1)*3, 'M').format('YYYY-MM-DD'), end = moment(temp_year + '-01-01').add(quarter*3, 'M').subtract(1, 'd').format('YYYY-MM-DD'); start < end; start = moment(start).add(1, 'M').format('YYYY-MM-DD')){
      let monthly = data.filter(promotions => { return moment(promotions.monthly_regulate).format('YYYY-MM-DD') == moment(start).format('YYYY-MM-DD')})
      let month_avg = 0
      let month_amount = 0
      for(let p = 0; p < provider_id_list.length; p++){
        let monthly_provider = monthly.filter(promotion => promotion.provider_id == provider_id_list[p])
        let main = monthly_provider.filter(type => type.promotion_type == 'main')[0]
        let ontop = monthly_provider.filter(type => type.promotion_type == 'on-top')[0]
        if(monthly_provider.length == 0) continue;
        if(moment(start).year() >= 2020){
          if((main.length != 0) && (ontop.length != 0)){
            if(ontop[service_amount[service_type]] != 0){
              month_avg += (((main[service_sum[service_type]]/main[service_amount[service_type]])*(propotion.main/100)) + ((ontop[service_sum[service_type]]/ontop[service_amount[service_type]])*(propotion.ontop/100))) * (main[service_amount[service_type]] + ontop[service_amount[service_type]])
              month_amount += (main[service_amount[service_type]] + ontop[service_amount[service_type]])
            } else {
              month_avg += main[service_sum[service_type]]
              month_amount += main[service_amount[service_type]]
            }
          } else if((main.length != 0) && (ontop.length == 0)){
            month_avg += main[service_sum[service_type]]
            month_amount += main[service_amount[service_type]]
          }
        } else {
          let temp_avg = monthly_fixed(monthly_provider)
          month_avg += temp_avg[service_type]
        }
      }
      if (month_amount != 0) {
        total_avg += (month_avg/month_amount)
        total_amount++;
      }
    }
    final.push(!isNaN(total_avg/total_amount) ? parseFloat((total_avg/total_amount).toFixed(2)) : null)
  }
  return final
}

export const Report_SC = {
    namespaced: true,
    state,
    actions,
    mutations
};